// extracted by mini-css-extract-plugin
export default {"csSurvey":"CustomerServiceSurvey_csSurvey__HM4y7","surveyCont":"CustomerServiceSurvey_surveyCont__6nSZ1","btnSurvey":"CustomerServiceSurvey_btnSurvey__zQJG6"};